export default __webpack_public_path__ + "static/media/trending1.2aa05a62.png";